import styled from 'styled-components';

export const StyledBookDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledBookDetail = styled.div`
  height: 75px;
  width: 525px;
  margin-bottom: 50px;
  background-color: #c4c4c4;
  font-family: 'NexonBo';
  text-align: left;
  font-size: 15px;
  line-height: 75px;
  padding-left: 20px;
  border-radius: 20px;
`;
